// Original TrustTrade dark palette, applied to the current customer components.
// Presentation only; financial state and action permissions stay in their existing resolvers.
export const Product = {
  bg: '#060607', bgGlow: 'radial-gradient(ellipse 1100px 560px at 50% -8%, #0B2E3D 0%, #0A0C0E 45%, #060607 100%)',
  surface: '#16181B', surfaceSolid: '#16181B', hover: 'rgba(255,255,255,0.05)', border: '#242830',
  accent: '#2F9BFF', accentGradient: 'linear-gradient(135deg, #178FE3 0%, #54B8FF 100%)',
  success: '#3DD194', error: '#F0665C', warn: '#F5AB1F', warnText: '#1A170F',
  text: '#F5F7FA', sub: '#9AA4B2', dim: '#8B95A5',
  mono: "'JetBrains Mono', monospace", sans: "'Space Grotesk', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  shadow: '0 8px 24px rgba(0,0,0,0.35)', radius: 16, radiusSm: 10,
};
